import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LoadedRecords = (props) => {
    const { t } = useTranslation();
    const { list, displayNOR } = props;
    return (
        <Col xs={12}>
            <p className="my-3 fs-6">
                {t("loaded")} {displayNOR > list.length ? list.length : displayNOR} {t("from")} {list.length} {t("records")}.
            </p>
        </Col>
    );
};

export default LoadedRecords;
